<!--
 * @Author: Src
 * @Date: 2024-12-18 09:26:58
 * @LastEditTime: 2024-12-25 09:38:43
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/InputField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <el-input v-model="val" :disabled="disabledType"/>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Model, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class InputField extends Vue {
    val: any = '';

    @Watch('val')
    watchInternalVal(): void {
        if (this.val !== null) {
            this.$emit('change', this.val);
        } else {
            this.$emit('change', '');
        }
    }


    @Model('change', {
        type: String,
    })
    value!: string;

    @Prop({
        type: Boolean,
        default: false,
    })
    disabledType!: boolean;

    @Watch('value')
    watchValue() {
        if (!this.value || this.value === '') {
            this.val = null;
            return;
        }
        this.val = this.value;
    }

    mounted() {
        this.watchValue();

    }
}
</script>
